export enum BroadcastChannelMessageType {
  LOGOUT = 'LOGOUT',
}
